<template>
  <div class="editor-container d-flex justify-center mt-5">
    <v-card v-if="districts" :color="`#f6f6f6`" flat rounded="xl">
      <template v-slot:title>
        <div class="d-flex">
          <span class="font-weight-bold">Выбор подразделения</span>
        </div>
      </template>
      <template v-slot:text>
        <v-autocomplete
            density="compact"
            flat
            hide-details
            variant="solo"
            style="min-width: 300px"
            label="Подразделение"
            item-title="name"
            item-value="guid"
            :items="districts"
            v-model="selected"
            class="my-2"
        />
      </template>
      <template v-slot:actions>
        <v-btn block rounded="xl" v-if="selected" v-on:click="go_to_editor()" variant="flat" color="light-green">
          <template v-slot:default>
            В РЕДАКТОР
          </template>
        </v-btn>
        <v-btn v-else block rounded="xl" variant="plain" color="deep-orange" disabled>
          <template v-slot:default>
            ПОДРАЗДЕЛЕНИЕ НЕ ВЫБРАНО
          </template>
        </v-btn>

      </template>
    </v-card>
  </div>
</template>


<script>
import { TokenGUIDStore } from "@/store/global/SessionStore";
import {clear_all} from "@/libs/wp/update_registered";

export default {
  name: "SelectDistrict",
  async beforeMount() {
    await this.get_available_districts()
  },
  mounted() {
    clear_all()
  },
  data() {
    return {
      loading: false,
      districts: null,
      selected: null
    }
  },
  methods: {
    go_to_editor: function () {
      this.$router.push({ name: 'wp__edit', params: { district: this.selected } })
    },
    get_available_districts: async function () {
      this.loading = true
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.BASE}/${this.$config.ONETEST}/AvailableDistricts`
      let meta = {
        method: 'GET',
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.session_token
        }
      }
      await fetch(url, meta)
          .then(async response => {
            if (response.ok) {
              return await response.json()
            } else {
              throw `Ошибка получения участков!`
            }
          })
          .then(async result => {
            this.districts = result
          }).catch(err => {
            console.warn(err)
          }).finally(() => {
            this.loading = false
          })
    }
  },
  computed: {
    session_token() {
      return TokenGUIDStore().get()
    },
  }
}
</script>
